export const cleanText = ({ removeSpace = false, string = '' }) => {
  let str = string;
  if (removeSpace) {
    str = string.replace(/ /g, '');
  }
  str = str.replace(/[\r\n]+/g, '');
  const result = str.replace(/[\u200B-\u200D\uFEFF]/g, '');
  return result;
};
